<template>
  <v-row>
    <v-col cols="12">
      <v-card flat rounded="lg">
        <v-card-subtitle class="font-weight-bold black--text subtitle-1"
          >Meus saldos</v-card-subtitle
        >
        <v-card-text>
          <v-row v-if="carregando">
            <v-col
              xl="3"
              lg="3"
              md="3"
              sm="12"
              cols="12"
              v-for="(num, i) in 4"
              :key="i"
            >
              <v-skeleton-loader
                class="mx-auto rounded-lg"
                max-height="150"
                min-width="200"
                type="image"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row v-else-if="saldos.length == 0">
            <v-col cols="12">
              <v-alert type="info" text
                >Não há saldos disponíveis para serem exibidos</v-alert
              >
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col
              xl="3"
              lg="3"
              md="3"
              sm="12"
              cols="12"
              v-for="(saldo, index) in saldosParaExibir"
              :key="index"
            >
              <v-card
                outlined
                class="h-100 rounded-lg"
                :hover="getProps(saldo).hover && !gerencial"
                min-width="200"
                :color="getProps(saldo).cor + ' lighten-5'"
                @click="onPressedSaldo(saldo)"
              >
                <v-card-title
                  :class="
                    getProps(saldo).cor +
                    '--text text--darken-1 font-weight-bold'
                  "
                >
                  {{ saldo.descricao }}
                </v-card-title>

                <v-card-subtitle
                  :class="getProps(saldo).cor + '--text text--darken-1'"
                >
                  {{ saldo.subdescricao }}
                  <span
                    v-if="saldo.conta === '11'"
                    class="pa-0 d-block"
                    style="font-size: 0.6em; margin-top: -7px"
                  >
                    *Sujeito a análise de crédito.
                  </span>
                </v-card-subtitle>

                <v-card-text>
                  <p
                    style="font-size: 1.4rem"
                    :class="
                      getProps(saldo).cor +
                      '--text text--darken-1 font-weight-bold'
                    "
                  >
                    {{ maskMoeda(saldo.saldo) }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <creditos-recebidos
            v-if="getCreditosRecebidos()"
            :creditos="getCreditosRecebidos().detalhe"
          />
          <gastos-conta-cliente v-if="getContasConsumo()" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import { formatMoeda } from "@/global";
import CreditosRecebidos from "./CreditosRecebidos.vue";
import { mapMutations, mapState } from "vuex";
import GastosContaCliente from "./GastosContaCliente.vue";

export default {
  components: { CreditosRecebidos, GastosContaCliente },
  computed: {
    ...mapState("usuario", ["gerencial"]),
    mesAtual() {
      return new Date().getMonth() + 1;
    },
    saldosParaExibir() {
      return this.saldos;
    },
  },
  data: () => ({
    carregando: false,
    saldos: [],
    cores: [
      { conta: "2", cor: "grey", hover: false },
      { conta: "87", cor: "green", hover: false },
      { conta: "11", cor: "blue", hover: false },
      { conta: "37", cor: "orange", hover: true },
      { conta: "91", cor: "teal", hover: true },
      { conta: "90", cor: "cyan", hover: false },
    ],
  }),
  methods: {
    ...mapMutations("home", [
      "setDialogCredRecebidos",
      "setDialogGastosCliente",
      "setDialogGastosConsumo",
    ]),
    maskMoeda(value) {
      return formatMoeda(value, 2);
    },
    getCreditosRecebidos() {
      return this.saldos.find((saldo) => saldo.conta == "91");
    },
    getContasConsumo() {
      return this.saldos.find((saldo) => saldo.conta == "11");
    },
    getProps(saldo) {
      return (
        this.cores.find((cor) => cor.conta == saldo.conta) || {
          cor: "grey",
          hover: false,
        }
      );
    },
    onPressedSaldo(saldo) {
      if (this.gerencial) {
        return;
      }

      if (saldo.conta == 91) {
        this.setDialogCredRecebidos(true);
      } else if (saldo.conta == 37) {
        this.setDialogGastosCliente(true);
      } else if (saldo.conta == 11) {
        this.$router.push("limites-consumo");
      }
    },
    async getSaldosContas() {
      this.saldos = [];
      await axios
        .get(`/colaborador/financeiro?funcao=SALDOS-CONTAS`)
        .then((res) => {
          if (res.data.success) {
            this.saldos = res.data.data;
          }
        });
    },
  },
  async mounted() {
    this.carregando = true;
    await this.getSaldosContas();
    this.carregando = false;
  },
};
</script>
